/**
 * @fileoverview Model for a sync policy.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {SyncedField, SyncedFieldJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfield';

export class GetSyncedFieldsResponse {
  /**
   * @param {{
   *  fields: !Array<SyncedField>,
   * }} params
   */
  constructor(params) {
    /** @type {!Array<SyncedField>} */
    this.fields = params.fields;
  }

  /**
   * @param {!GetSyncedFieldsResponseJson} json
   * @return {!GetSyncedFieldsResponse}
   */
  static fromJSON(json) {
    return new GetSyncedFieldsResponse({
      fields: json['fields'].map(SyncedField.fromJSON),
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  fields: !Array<SyncedFieldJson>,
 * }}
 */
export let GetSyncedFieldsResponseJson;
